import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Form for user state
        const estado_usuario = {
            view: 'form',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            id: 'estadoUsuario',
            rows: [
                { view: 'label', label: _('Estado de Máquina') }, // Label for machine state
                {
                    css: 'centrar',
                    id: 'StateSwith', // Switch for user state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateSwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"A"}', // Activate user
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateSwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"I"}', // Deactivate user
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateSwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for contingency state
        const estado_contingencia = {
            view: 'form',
            id: 'Contingency',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia') }, // Label for contingency state
                {
                    id: 'StateContingencySwith', // Switch for contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateContingencySwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"A"}', // Activate contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencySwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"I"}', // Deactivate contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencySwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for sports contingency state
        const estado_contingenciaDeportivas = {
            view: 'form',
            id: 'ContingencyDeportivas',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Deportivas') }, // Label for sports contingency
                {
                    id: 'StateContingencyDeportivasSwith', // Switch for sports contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateContingencyDeportivasSwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"A"}', // Activate sports contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyDeportivasSwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"I"}', // Deactivate sports contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyDeportivasSwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for casino contingency state
        const estado_contingenciaCasino = {
            view: 'form',
            id: 'ContingencyCasino',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Casino') }, // Label for casino contingency
                {
                    id: 'StateContingencyCasinoSwith', // Switch for casino contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateContingencyCasinoSwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"A"}', // Activate casino contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyCasinoSwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"I"}', // Deactivate casino contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyCasinoSwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for live casino contingency state
        const estado_contingenciaCasinoVivo = {
            view: 'form',
            id: 'ContingencyCasinoVivo',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Casino en Vivo') }, // Label for live casino contingency
                {
                    id: 'StateContingencyCasinoVivoSwith', // Switch for live casino contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateContingencyCasinoVivoSwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"A"}', // Activate live casino contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyCasinoVivoSwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"I"}', // Deactivate live casino contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyCasinoVivoSwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for virtual contingency state
        const estado_contingenciaVirtuales = {
            view: 'form',
            id: 'ContingencyVirtuales',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia Virtuales') }, // Label for virtual contingency
                {
                    id: 'StateContingencyVirtualesSwith', // Switch for virtual contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateContingencyVirtualesSwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"A"}', // Activate virtual contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyVirtualesSwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"I"}', // Deactivate virtual contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyVirtualesSwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for poker contingency state
        const estado_contingenciaPoker = {
            view: 'form',
            id: 'ContingencyPoker',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia Poker') }, // Label for poker contingency
                {
                    id: 'StateContingencyPokerSwith', // Switch for poker contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateContingencyPokerSwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"A"}', // Activate poker contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyPokerSwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"I"}', // Deactivate poker contingency
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyPokerSwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Form for IP restriction contingency state
        const estado_contingenciaRestriccionIP = {
            view: 'form',
            id: 'ContingencyRestriccionIP',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Restricción IP') }, // Label for IP restriction
                {
                    view: 'text',
                    name: 'IP',
                    id: 'IP', // Input for IP address
                    placeholder: _('IP'), // Placeholder for IP input
                },
                {
                    id: 'StateContingencyRestriccionIPSwith', // Switch for IP restriction state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event for the switch
                        if ($$('StateContingencyRestriccionIPSwith').getValue() == 1) {
                            // If switch is active
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                        cur_user +
                                        ',"IsActivate":"A","IP":"' +
                                        $$('IP').getValue() +
                                        '"}', // Activate IP restriction
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyRestriccionIPSwith').setValue(1); // Set switch value
                                        },
                                    },
                                );
                        } else {
                            // If switch is inactive
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                        cur_user +
                                        ',"IsActivate":"I","IP":"' +
                                        $$('IP').getValue() +
                                        '"}', // Deactivate IP restriction
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(
                                                _('Cambios Realizados'), // Success message
                                            );
                                            $$('StateContingencyRestriccionIPSwith').setValue(0); // Set switch value
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Return the layout structure of the view
        return {
            rows: [
                {
                    cols: [
                        estado_usuario,
                        estado_contingencia,
                        estado_contingenciaDeportivas,
                        estado_contingenciaCasino,
                    ],
                },
                {
                    cols: [
                        estado_contingenciaCasinoVivo,
                        estado_contingenciaVirtuales,
                        estado_contingenciaPoker,
                        estado_contingenciaRestriccionIP,
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and fetches user data.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        webix.html.addStyle(
            '.bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }', // Style for red background
        );
        webix.html.addStyle(
            '.bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }', // Style for green background
        );
        webix.ajax().get(
            devConfig.geturlApi() + 'Client/GetClientSpById',
            'id=' + cur_user, // Fetch user data by ID
            {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse response text
                    $$('IP').setValue(text[0].IP); // Set IP value
                    if (text[0].IsActivate == 'A') {
                        $$('StateSwith').setValue(1); // Set switch value for active
                    } else {
                        $$('StateSwith').setValue(0); // Set switch value for inactive
                    }
                    if (text[0].IsActivateContingency == 'A') {
                        $$('StateContingencySwith').setValue(1); // Set switch value for active contingency
                    } else {
                        $$('StateContingencySwith').setValue(0); // Set switch value for inactive contingency
                    }
                    if (text[0].IsActivateContingencyDeportivas == 'A') {
                        $$('StateContingencyDeportivasSwith').setValue(1); // Set switch value for active sports contingency
                    } else {
                        $$('StateContingencyDeportivasSwith').setValue(0); // Set switch value for inactive sports contingency
                    }
                    if (text[0].IsActivateContingencyCasino == 'A') {
                        $$('StateContingencyCasinoSwith').setValue(1); // Set switch value for active casino contingency
                    } else {
                        $$('StateContingencyCasinoSwith').setValue(0); // Set switch value for inactive casino contingency
                    }
                    if (text[0].IsActivateContingencyCasinoVivo == 'A') {
                        $$('StateContingencyCasinoVivoSwith').setValue(1); // Set switch value for active live casino contingency
                    } else {
                        $$('StateContingencyCasinoVivoSwith').setValue(0); // Set switch value for inactive live casino contingency
                    }
                    if (text[0].IsActivateContingencyVirtuales == 'A') {
                        $$('StateContingencyVirtualesSwith').setValue(1); // Set switch value for active virtual contingency
                    } else {
                        $$('StateContingencyVirtualesSwith').setValue(0); // Set switch value for inactive virtual contingency
                    }
                    if (text[0].IsActivateContingencyPoker == 'A') {
                        $$('StateContingencyPokerSwith').setValue(1); // Set switch value for active poker contingency
                    } else {
                        $$('StateContingencyPokerSwith').setValue(0); // Set switch value for inactive poker contingency
                    }
                    if (text[0].IsRestrictionIP == 'A') {
                        $$('StateContingencyRestriccionIPSwith').setValue(
                            1, // Set switch value for active IP restriction
                        );
                    } else {
                        $$('StateContingencyRestriccionIPSwith').setValue(
                            0, // Set switch value for inactive IP restriction
                        );
                    }
                    console.log(text); // Log the fetched user data
                },
            },
        );
    }
}

// FILE DOCUMENTED
